<template>
  <CRow>
    <CCol col="12" lg="6">
      <CCard no-header>
        <CCardBody>
          <h4>
            Send Email
          </h4>
          <CModal
            class="modalAlert"
            :show.sync="alertIsShown"
            :centered="true"
            size="lg"
          >
            <CAlert
              closeButton
              :show.sync="alertIsShown"
              color="primary"
              fade
            >
              {{ message }}
            </CAlert>
          </CModal>

            <CInput label="Email" type="text" placeholder="Email" v-model="email"></CInput>

          <CButton color="primary" @click="store()">Send</CButton>
          <CButton color="primary" @click="goBack">Back</CButton>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'
export default {
  name: 'SendEmail',
  data: () => {
    return {
        email: '',
        template: {
            name: '',
            subject: '',
            content: '',
        },
        message: '',
        dismissSecs: 7,
        alertIsShown: false,
        dismissCountDown: 0,
        showDismissibleAlert: false
    }
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
      // this.$router.replace({path: '/users'})
    },
    store() {
        let self = this;
        axios.post(  '/api/mailSend/' + self.$route.params.id + '?token=' + localStorage.getItem("api_token"),
          {email: self.email}
        )
        .then(function (response) {
            self.email = ''
            self.message = 'Επιτυχής αποστολή Email.';
            self.showAlert();
        }).catch(function (error) {
            if(error.response.data.message == 'The given data was invalid.'){
              self.message = '';
              for (let key in error.response.data.errors) {
                if (error.response.data.errors.hasOwnProperty(key)) {
                  self.message += error.response.data.errors[key][0] + '  ';
                }
              }
              self.showAlert();
            }else{
              console.log(error);
              self.$router.push({ path: 'login' }); 
            }
        });
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },
  },
  mounted: function(){
    let self = this;
    axios.get(  '/api/prepareSend/' + self.$route.params.id + '?token=' + localStorage.getItem("api_token"))
    .then(function (response) {
      self.template = response.data.template;
    }).catch(function (error) {
      console.log(error);
      self.$router.push({ path: '/login' });
    });
  }
}

</script>
